<template>
    <div class="mt-4">
        <WorkflowStep
            :assigned-workflows="assignedReservationMadeWorkflows"
            :unassigned-workflows="unassignedReservationMadeWorkflows"
            :title="$t('workflows.steps.when_reservation_is_made')"
            @assign-workflow="(id) => assignWorkflow(id)"
            @detach-workflow="(id) => detachWorkflow(id)"
            :integrations="integrations"
            :trigger="'reservation_made'"
            :event-type="eventType"
            :is-owner="isOwner"
            :is-personal-in-team="isPersonalInTeam"
        ></WorkflowStep>

        <WorkflowStep
            :assigned-workflows="assignedResrvationsCanceledWorkflows"
            :unassigned-workflows="unassignedResrvationsCanceledWorkflows"
            :title="$t('workflows.steps.when_reservation_is_canceled')"
            @assign-workflow="(id) => assignWorkflow(id)"
            @detach-workflow="(id) => detachWorkflow(id)"
            :integrations="integrations"
            :trigger="'reservation_canceled'"
            :event-type="eventType"
            :is-owner="isOwner"
            :is-personal-in-team="isPersonalInTeam"
        ></WorkflowStep>

        <WorkflowStep
            :assigned-workflows="assignedReservationWillHappenInWorkflows"
            :unassigned-workflows="unassignedReservationWillHappenInWorkflows"
            :title="$t('workflows.steps.when_reservation_will_happen_in')"
            @assign-workflow="(id) => assignWorkflow(id)"
            @detach-workflow="(id) => detachWorkflow(id)"
            :integrations="integrations"
            :is-last="true"
            :trigger="'reservation_will_happen_in'"
            :event-type="eventType"
            :is-owner="isOwner"
            :is-personal-in-team="isPersonalInTeam"
        ></WorkflowStep>
    </div>
</template>

<script setup lang="ts">
import { router, usePage } from "@inertiajs/vue3";
import type { EventType } from "../types/EventType";
import route from "ziggy-js";
import type { Workflow } from "../../Workflows/components/Workflow.vue";

import { computed } from "vue";
import WorkflowStep from "./Workflows/WorkflowStep.vue";

const props = defineProps<{
    eventType: EventType & { workflows: Workflow[] };
    workflows: Workflow[];
    isOwner: boolean;
    isPersonalInTeam: boolean;
    integrations: any[];
}>();
console.log(props);

type SharedData = {
    userId: number;
};

const page = usePage<SharedData>();

const detachWorkflow = function (workflowId: number) {
    if (!props.isOwner) {
        return;
    }

    router.post(
        route("app.event-types.workflows.detach", {
            eventType: props.eventType.id,
        }),
        {
            workflowId: workflowId,
            isPersonalInTeam: props.isPersonalInTeam,
        },
        {
            onFinish: () => {},
        },
    );
};

const assignWorkflow = function (workflowId: number) {
    if (!props.isOwner) {
        return;
    }

    router.post(
        route("app.event-types.workflows.assign", {
            eventType: props.eventType.id,
        }),
        {
            workflowId: workflowId,
            isPersonalInTeam: props.isPersonalInTeam,
        },
        {
            onFinish: () => {},
        },
    );
};

const unassignedReservationMadeWorkflows = computed(() => {
    return props.workflows.filter(
        (workflow) =>
            workflow.trigger === "reservation_made" &&
            !isWorkflowAlreadyAssigned(workflow.id, props.eventType.workflows),
    );
});

const assignedReservationMadeWorkflows = computed(() => {
    return props.workflows.filter(
        (workflow) =>
            workflow.trigger === "reservation_made" &&
            isWorkflowAlreadyAssigned(workflow.id, props.eventType.workflows),
    );
});

const assignedResrvationsCanceledWorkflows = computed(() => {
    return props.workflows.filter(
        (workflow) =>
            workflow.trigger === "reservation_canceled" &&
            isWorkflowAlreadyAssigned(workflow.id, props.eventType.workflows),
    );
});

const unassignedResrvationsCanceledWorkflows = computed(() => {
    return props.workflows.filter(
        (workflow) =>
            workflow.trigger === "reservation_canceled" &&
            !isWorkflowAlreadyAssigned(workflow.id, props.eventType.workflows),
    );
});

const assignedReservationWillHappenInWorkflows = computed(() => {
    return props.workflows.filter(
        (workflow) =>
            workflow.trigger === "reservation_will_happen_in" &&
            isWorkflowAlreadyAssigned(workflow.id, props.eventType.workflows),
    );
});

const unassignedReservationWillHappenInWorkflows = computed(() => {
    return props.workflows.filter(
        (workflow) =>
            workflow.trigger === "reservation_will_happen_in" &&
            !isWorkflowAlreadyAssigned(workflow.id, props.eventType.workflows),
    );
});

const isWorkflowAlreadyAssigned = (id: number, assignedWorkflows: any) => {
    console.log(assignedWorkflows);
    for (let i = 0; i < assignedWorkflows.length; i++) {
        if (
            props.isPersonalInTeam &&
            assignedWorkflows[i].id === id &&
            assignedWorkflows[i].pivot.user_id === page.props.userId
        ) {
            return true;
        }

        if (
            !props.isPersonalInTeam &&
            assignedWorkflows[i].id === id &&
            assignedWorkflows[i].pivot.user_id === null
        ) {
            return true;
        }
    }
    return false;
};
</script>

<style></style>
